import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import { useLocation } from "react-router-dom";
import {
  getBillReceipt,
} from "requests/user";
// import dataerrer from '../assets/images/data-errer.gif'

const BillPayReceipt = () => {
  
  const [receiptData, setReceiptData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const receiptId  = queryParams.get('_id');
  const { id: receiptId } = useParams();
  const token = localStorage.getItem('token');

useEffect(() => {
    if (!receiptId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getBillReceipt({ receipt_id: receiptId });
        const data = response.data;

        if (data.status === 1 && data.data.length > 0) {
          const matchedData = data.data.find((item) => item._id === receiptId);
          setReceiptData(matchedData || null);
        } else {
          setReceiptData(null);
        }
      } catch (error) {
        console.error("Error fetching receipt data:", error);
        setReceiptData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [receiptId]);


  const handleDownload = () => {
    const receiptElement = document.getElementById("receipt");

    html2canvas(receiptElement).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      pdf.save("receipt.pdf");
    });
  };

  if (loading) return <p>Loading...</p>;
  if (!receiptData) return <div className="d-flex justify-content-center align-items-center flex-column">
{/* <img src={dataerrer} alt="" /> */}
    <p className="text-center">No receipt data found.</p>
  </div> 
  
  return (
    <div className="billpaymentdesign" >
    <h1 className="font-weight-bold fs-3 ">Bill Payment Receipt</h1>
      <div className="container">
        <div id="receipt">
          <div className="receipt-container">
            <p className="success-message background-color-new"><strong>Transaction Status: {receiptData.status}</strong></p>
            <table className="receipt-table">
              <tbody>
                <tr>
                  <th>Biller Name</th> <td>{receiptData.operator_name}</td>
                  <th>Biller Amount</th> <td>{receiptData.amount}</td>
                </tr>
                <tr>
                  <th>Biller ID</th> <td>{receiptData.bill_category_id}</td>
                  <th>CCF</th> <td>{receiptData.CustConvFee}</td>
                </tr>
                <tr>
                  <th>Txn Ref ID</th> <td>{receiptData.txnRefId}</td>
                  <th>Total Amount</th> <td>{parseFloat(receiptData.amount) + parseFloat(receiptData.CustConvFee)}</td>
                </tr>
                <tr>
                  <th>Customer Name</th> <td>{receiptData.customer_name}</td>
                  <th>Txn Date & Time</th> <td>{receiptData.date_time}</td>
                </tr>
                <tr>
                  <th>Mobile Number</th> <td>{receiptData.user_mobile}</td>
                  <th>Payment Channel</th> <td>Online</td>
                </tr>
                <tr>
                  <th>Bill Date</th> <td>{receiptData.bill_date}</td>
                  <th>Payment Mode</th> <td>{receiptData.paymentMode}</td>
                </tr>
                <tr>
                  <th>Bill Period</th> <td>{receiptData.billperiod}</td>
                  <th>Transaction Status</th> <td>{receiptData.status}</td>
                </tr>
                <tr>
                  <th>Bill Number</th> <td>{receiptData.bill_number}</td>
                  <th>Approved Number</th> <td>{receiptData.approvalRefNumber}</td>
                </tr>
                <tr>
                  <th>Due Date</th> <td>{receiptData.due_date}</td>
                  <td colSpan="2"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-3 w-100">
          <button className="download-button btn btn-primary" onClick={handleDownload}>
            Download Receipt
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillPayReceipt;
